import * as ReselectModule from "reselect";
import { IAssistanceListState } from ".";
import { IApplicationState } from "..";

export const selectAssistanceList: ReselectModule.Selector<
  IApplicationState,
  IAssistanceListState
> = (state) => state.assistanceList;
